import { useTranslation } from 'react-i18next'

const stats = [
  {
    emoji: '📈',
    valueKey: 'pages.checkout.successStats.stat1Value',
    labelKey: 'pages.checkout.successStats.stat1Label',
  },
  {
    emoji: '🗣️',
    valueKey: 'pages.checkout.successStats.stat2Value',
    labelKey: 'pages.checkout.successStats.stat2Label',
  },
  {
    emoji: '⭐',
    valueKey: 'pages.checkout.successStats.stat3Value',
    labelKey: 'pages.checkout.successStats.stat3Label',
  },
]

export default function SuccessStats() {
  const { t } = useTranslation()

  return (
    <div className="grid grid-cols-3 gap-3">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="rounded-xl border border-[#9699AE] bg-white p-3 text-center"
        >
          <span className="mb-1 block text-2xl">{stat.emoji}</span>
          <p className="text-primary text-lg font-bold wrap-break-word hyphens-auto">
            {t(stat.valueKey)}
          </p>
          <p className="text-xs wrap-break-word hyphens-auto text-[#9699AE]">
            {t(stat.labelKey)}
          </p>
        </div>
      ))}
    </div>
  )
}
